"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WAD_BigInt = exports.WAD = void 0;
const bignumber_js_1 = __importDefault(require("bignumber.js"));
/** @internal */
exports.WAD = new bignumber_js_1.default('1e+18');
/** @internal */
exports.WAD_BigInt = BigInt(exports.WAD.toString());
